import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { InputBaseContainer, TextAreaWithLabel } from '../../../../../molecules';
import { labels } from '../constants';
import { RootState } from '../../../../../redux/root';

const GateCode = ({ register, errors }) => {
  const disabledGlobalSearch = useSelector((s: RootState) => s.inspections.disabledGlobalSearch);
  return (
    <InfoWrapper>
      <InputBaseContainer>
        <TextAreaWithLabel
          showInRow
          name="gateCode"
          error={errors.gateCode}
          label={labels.gateCode}
          inputRef={register}
          maxChar={2000}
          disabled={disabledGlobalSearch}
        />
      </InputBaseContainer>
    </InfoWrapper>
  );
};

export default GateCode;

const InfoWrapper = styled.div`
 
`;
